import localFont from 'next/font/local';

export const jetBrainsMono = localFont({
  variable: '--font-jetbrains-mono',
  src: [
    {
      path: './static/JetBrainsMono-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './static/JetBrainsMono-SemiBold.woff2',
      weight: '600',
      style: 'normal',
    },
  ],
});

export const mackinacPro = localFont({
  variable: '--font-mackinac-pro',
  src: [
    {
      path: './static/P22MackinacProMedium.woff2',
      weight: '500',
      style: 'normal',
    },
  ],
});

export const messinaSans = localFont({
  variable: '--font-messina-sans',
  src: [
    {
      path: './static/MessinaSansWeb-VF-Upright.woff2',
      style: 'normal',
    },
  ],
});

export function mergeIntoNextFontFamily(
  nextFont: ReturnType<typeof localFont>,
  otherFonts: Array<string>
): string {
  return [nextFont.style.fontFamily, otherFonts.join(', ')].join(', ');
}

export const BRAND_FONT_VARIABLES = [
  messinaSans.variable,
  mackinacPro.variable,
  jetBrainsMono.variable,
].join(' ');
